export const Types = {
  SET: 'users/SET',
  REFRASH: 'users/REFRASH',
  CLEAR: 'users/CLEAR',
  UPDATE: 'users/UPDATE',
  UPDATE_SUCCSS: 'users/UPDATE_SUCCSS',
  UPDATE_ERROR: 'users/UPDATE_ERROR',
  GET_REQUEST: 'users/GET_REQUEST',
  GET_SUCCESS: 'users/GET_SUCCESS',
  UPDATE_CONFIRMATION: 'users/UPDATE_CONFIRMATION',
};

const INITIAL_STATE = {
  id: null,
  nickname: null,
  email: null,
  ddd: null,
  phone: null,
  subscription: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.SET:
    case Types.CLEAR:
      return { ...state, ...action.payload };
    case Types.UPDATE:
      return { ...state, updateLoading: true };
    case Types.UPDATE_SUCCSS:
    case Types.UPDATE_ERROR:
      return { ...state, updateLoading: false };
    case Types.GET_REQUEST:
      return { ...state, loading: true };
    case Types.GET_SUCCESS:
      if (action.payload.data === null) {
        return state;
      }
      return { ...state, ...action.payload.data, loading: false };
    case Types.UPDATE_CONFIRMATION:
      return { ...state, updateLoading: true };
    default:
      return state;
  }
};

export const Creators = {
  loadUser: user => ({
    type: Types.SET,
    payload: { ...user },
  }),
  refrashUser: () => ({ type: Types.REFRASH }),
  update: (id, nickname, email) => ({
    type: Types.UPDATE,
    id,
    nickname,
    email,
  }),
  updateSuccess: () => ({ type: Types.UPDATE_SUCCSS }),
  updateError: () => ({ type: Types.UPDATE_ERROR }),
  clearSession: () => {
    const payload = {};
    Object.keys(INITIAL_STATE).map(attr => (payload[attr] = null));
    return {
      type: Types.CLEAR,
      payload,
    };
  },
  getUserConfirmationRequest: token => ({ type: Types.GET_REQUEST, token }),
  getUserConfirmationSuccess: data => ({
    type: Types.GET_SUCCESS,
    payload: { data },
  }),
  updateUserConfirmation: (token, id, nickname, email, password) => ({
    type: Types.UPDATE_CONFIRMATION,
    token,
    id,
    nickname,
    email,
    password
  }),
};



// WEBPACK FOOTER //
// ./src/store/ducks/user.js